/**
 * Flash Sale countdown — Doctor+Mattress
 * Counts down to a fixed end date/time set via the section schema
 * (data-end-date, an ISO 8601 string, e.g. "2026-09-15T23:59:59+01:00").
 */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initFlashSale(section) {
    var endAttr = section.getAttribute('data-end-date');
    if (!endAttr) return;

    var endTime = new Date(endAttr).getTime();
    if (isNaN(endTime)) return;

    var daysEl = section.querySelector('[data-fs-days]');
    var hoursEl = section.querySelector('[data-fs-hours]');
    var minsEl = section.querySelector('[data-fs-mins]');
    var secsEl = section.querySelector('[data-fs-secs]');

    var timer = null;

    function tick() {
      var now = Date.now();
      var diff = endTime - now;

      if (diff <= 0) {
        section.classList.add('is-ended');
        if (timer) clearInterval(timer);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minsEl) minsEl.textContent = pad(mins);
      if (secsEl) secsEl.textContent = pad(secs);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('.flash-sale-section').forEach(initFlashSale);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when Shopify's theme editor swaps section HTML in/out.
  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.flash-sale-section');
    if (section) initFlashSale(section);
  });
})();
